import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PetService} from '../../services/pet.service';
import {Option, StaticMethods} from '../../model/GeneralModels';

class DialogData {
  requestID: number;
}

interface Clinic {
  clinicName: string;
  address: string;
}

interface Schedule {
  id: number;
  dayPersianName: string;
  startTime: number;
  endTime: number;
  recordDate: number;
  clinics: Option[];
}

interface ViewInfo {
  id: number;
  day: string;
  startHour: string;
  endHour: string;
  date: string;
  clinicCount: number;
}

@Component({
  selector: 'app-reservation-dialog',
  templateUrl: './reservation-dialog.component.html',
  styleUrls: ['./reservation-dialog.component.css']
})
export class ReservationDialogComponent implements OnInit {
  formGroup: FormGroup = this.fb.group({
    clinicID: ['', Validators.required],
    recordDate: ['', Validators.required]
  });
  viewInfo: ViewInfo[];
  selected: Schedule = null;
  requestID: number;
  weekCount = 1;
  schedules: Schedule[] = [];
  translation: any = {};
  visitType: string;

  ngOnInit(): void {
    this.getSchedule();
  }

  constructor(
    public dialogRef: MatDialogRef<ReservationDialogComponent>, private petService: PetService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private fb: FormBuilder) {
    this.requestID = data.requestID;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getSchedule() {
    this.schedules = [];
    this.petService.getAvailableReservation(this.requestID, this.weekCount).subscribe(response => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.schedules = [];
        this.viewInfo = [];
        let counter = 1;
        console.log(response);
        response.data.schedules.forEach(schedule => {
          schedule.id = counter;
          this.schedules.push(schedule);
          this.viewInfo.push({
            id: schedule.id,
            date: StaticMethods.getjalaliDate(new Date(schedule.recordDate)),
            day: schedule.dayPersianName,
            startHour: schedule.startTime + ':00',
            endHour: schedule.endTime + ':00',
            clinicCount: schedule.clinics ? schedule.clinics.length : 0,
          });
          counter++;
        });
        this.visitType = response.data.visitType;
        this.selected = null;
        if (this.visitType === 'ON_DOOR') {
          this.formGroup.controls.clinicID.setValidators([]);
        } else {
          this.formGroup.controls.clinicID.setValidators([Validators.required]);
        }
      }
    });
  }

  getWeek(weekCount) {
    this.weekCount = weekCount;
    this.getSchedule();
  }

  submit() {
    const body = this.formGroup.value;
    body.requestID = this.requestID;
    body.weekCount = this.weekCount;
    this.petService.bookReservation(body).subscribe(response => {
      if (response.success) {
        this.dialogRef.close(true);
      }
    });
  }

  selectChanged(selected: ViewInfo) {
    if (!selected) {
      this.formGroup.controls.clinicID.patchValue('');
      this.formGroup.controls.recordDate.patchValue('');
    } else {
      this.selected = this.schedules.find(schedule => {
        return schedule.id === selected.id;
      });
      if (this.selected) {
        this.formGroup.controls.clinicID.patchValue('');
        this.formGroup.controls.recordDate.patchValue(this.selected.recordDate);
      }
    }
  }
}
